import React from 'react';

import { useSiteHardwareConfigurationType } from '../../common/hooks/use-site-hardware-configuration-type';
import { AylaOnlyActivity } from './ayla-only/AylaOnlyActivity';
import { DefaultActivity } from './default/DefaultActivity';
import { SenseOnlyActivity } from './sense-only/SenseOnlyActivity';

export function Activity() {
  const { hardwareConfigurationType } = useSiteHardwareConfigurationType();

  return (
    {
      sense: <SenseOnlyActivity />,
      default: <DefaultActivity />,
      ayla: <AylaOnlyActivity />,
      evse: null,
      none: null,
    }[hardwareConfigurationType] ?? null
  );
}
